<template>
    <div>
        <SettingsCardTitle>
            <i class="fa fa-business-time mr-1"/>
            {{ __('general.reservations') }}
        </SettingsCardTitle>

        <FormGroupNew :label="__('general.reservations')"
                      :error="settings.errors.enabled"
                      required
        >
            <Checkbox v-model="settings.enabled">
                {{ __('reservations.activation') }}
            </Checkbox>
        </FormGroupNew>

        <FormGroupNew :label="__('reservations.contact')"
                      :description="__('reservations.contact_description')"
                      required
        >
            <input type="email" class="form-control" v-model="settings.contact" :disabled="!settings.enabled">
        </FormGroupNew>

        <div class="row">
            <div class="col-md-6">
                <FormGroupNew :label="__('reservations.default_accept_message')"
                              :description="__('reservations.default_accept_message_description')"
                              :error="settings.errors.acceptText"
                              required
                >
                    <textarea type="text" class="form-control" v-model="settings.acceptText"
                              :disabled="!settings.enabled"/>
                </FormGroupNew>
            </div>
            <div class="col-md-6">
                <FormGroupNew :label="__('reservations.default_reject_message')"
                              :description="__('reservations.default_reject_message_description')"
                              :error="settings.errors.declineText"
                              required
                >
                    <textarea type="text" class="form-control" v-model="settings.declineText"
                              :disabled="!settings.enabled"/>
                </FormGroupNew>
            </div>
        </div>

        <div>
            <DividerDotted class="mb-3"/>
            <SaveAndEnableButton :for="settings" @click="save"/>
        </div>
    </div>
</template>

<script>
import Navigation from './Nav/Navigation.vue'
import Errors from "@components/Errors.vue";
import SettingsCardTitle from "@components/Form/SettingsCardTitle.vue";
import FormGroupNew from "@components/Form/FormGroupNew.vue";
import Checkbox from "@components/Form/Checkbox.vue";
import DividerDotted from "@components/Form/DividerDotted.vue";
import SaveAndEnableButton from "@components/Integrations/SaveAndEnableButton.vue";

export default {
    layout: Navigation,

    components: {SaveAndEnableButton, DividerDotted, Checkbox, FormGroupNew, SettingsCardTitle, Errors},

    props: {
        store: Object,
        errors: Object,
        reservationsAreEnabled: Boolean,
        reservationsContact: String,
    },

    data() {
        return {
            settings: this.$inertia.form({
                enabled: this.reservationsAreEnabled,
                contact: this.reservationsContact,
                acceptText: this.store.attributes.reservations?.text_accept,
                declineText: this.store.attributes.reservations?.text_decline,
            })
        }
    },

    methods: {
        save() {
            this.settings.post(this.$route('store.reservations.update', this.store.id))
        }
    }
}
</script>
